import React, { useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import moment from "moment";
import { Mensaje } from "../../components/mensajes";
import CatalogoAlmacen from "../../catalogos/catalogoAlmacen";
import CatalogoCliente from "../../catalogos/catalogoCliente";

export const ModalPedidosPendientes = (props) => {
  const afiliado = JSON.parse(sessionStorage.getItem("riforganizacion"));
  var op = require("../../../public/modulos/datos");

  const txtDesde = useRef();
  const txtHasta = useRef();
  const txtpedido = useRef();
  const txtproducto = useRef();
  const txtNombreAlmacen = useRef();
  const txtCodigoAlmacen = useRef();
  const txtNombreVendedor = useRef();
  const txtRifVendedor = useRef();
  const [desde, setDesde] = useState("");
  const [hasta, setHasta] = useState("");
  const [actAlmacen, setActAlmacen] = useState(true);
  const [actCliente, setActCliente] = useState(true);
  const [mostrarAlmacen, setMostrarAlmacen] = useState(false);
  const [mostrarCliente, setMostrarCliente] = useState(false);
  const [idAlmacen, setIdAlmacen] = useState("");
  const [idVendedor, setIdVendedor] = useState("");
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });

  const cancelar = () => {
    blanquear();
    props.onHideCancelar();
  };
  const onChangeValidar = (e) => {
    e.preventDefault();
    imprimir();
  };
  const onChange = (e) => {
    if (e.target.name === "desde") {
      if (e.target.value > moment(new Date()).format("YYYY-MM-DD")) {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto:
            "¡ La Fecha seleccionada no puede ser Mayor a la Fecha Actual !",
          icono: "informacion",
        });
        txtDesde.current.value = moment(new Date()).format("YYYY-MM-DD");
        txtDesde.current.focus();
      } else {
        setDesde(e.target.value);
      }
    } else if (e.target.name === "hasta") {
      setHasta(e.target.value);
    }
  };
  const imprimir = () => {
    let ope = 0;
    let condicion = "";
    let condiciones = [];

    if (idAlmacen !== "" || idVendedor !== "") {
      if (idVendedor !== "") {
        condiciones.push(`p.idvendedor = ${idVendedor}`);
      }
      if (idAlmacen !== "") {
        condiciones.push(`p.idalmacen = ${idAlmacen}`);
      }

      if (condiciones.length > 0) {
        condicion = " AND " + condiciones.join(" AND ");
      }
    }
    if (txtproducto && txtproducto.current && txtproducto.current.checked) {
      ope = 1;
    }
    window.open(
      `${op.reportes}/ventas?afiliado=${afiliado}&reporte=ReporteListaPedidosPendiente&desde='${desde}'&hasta='${hasta}'&ope=${ope}&condicion='${condicion}'`,
      "Planilla",
      "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
    );
  };
  const handleAceptaAlmacen = (values) => {
    setMostrarAlmacen(false);
    txtNombreAlmacen.current.value = values.descripcion;
    txtCodigoAlmacen.current.value = values.idalmacen;
    setIdAlmacen(values.idalmacen);
  };
  const handleAceptaVendedor = (values) => {
    setMostrarCliente(false);
    txtNombreVendedor.current.value = values.nombre;
    txtRifVendedor.current.value = values.rif;
    setIdVendedor(values.idagente);
  };
  const blanquear = () => {
    setMostrarAlmacen(false);
    setMostrarCliente(false);
    setIdAlmacen("");
    setIdVendedor("");
    setActAlmacen(true);
    setActCliente(true);
    txtNombreVendedor.current.value = "";
    txtRifVendedor.current.value = "";
    txtNombreAlmacen.current.value = "";
    txtCodigoAlmacen.current.value = "";
  };
  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
      onShow={() => {
        blanquear();
        txtDesde.current.value = moment(new Date()).format("YYYY-MM-DD");
        txtHasta.current.value = moment(new Date()).format("YYYY-MM-DD");
        setDesde(moment(new Date()).format("YYYY-MM-DD"));
        setHasta(moment(new Date()).format("YYYY-MM-DD"));
      }}
    >
      <Modal.Header className="azulGradiant2 header-modal">
        <div className="fw-bold" style={{ color: "#fff" }}>
          <h3>Imprimir Pedidos Pendientes</h3>
        </div>

        <a href="#" onClick={cancelar} className="text-light">
          <i className="fas fa-times fa-1x shadow" />
        </a>
      </Modal.Header>
      <Modal.Body style={{ backgroundColor: "#FFF" }}>
        <Mensaje
          mensaje={mensaje}
          onHide={() =>
            setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" })
          }
        />
        <div className="col-md-12 row mx-auto px-0 m-0">
          <div className="col-12 row m-0 px-0 py-2">
            <div className="col-6 input-group input-group-sm">
              <label className="input-group-text" id="inputGroup-sizing-sm">
                DESDE:
              </label>
              <input
                type="date"
                name="desde"
                ref={txtDesde}
                onChange={onChange}
                className="form-control text-center fs-6 text-uppercase"
                aria-label="Sizing example input"
                aria-describedby="inputGroup-sizing-sm"
              />
            </div>
            <div className="col-6 input-group input-group-sm">
              <label className="input-group-text" id="inputGroup-sizing-sm">
                HASTA:
              </label>
              <input
                type="date"
                ref={txtHasta}
                name="hasta"
                onChange={onChange}
                className="form-control text-center fs-6 text-uppercase"
                aria-label="Sizing example input"
                aria-describedby="inputGroup-sizing-sm"
              />
            </div>
          </div>
          <fieldset className="row col-sm-12 mx-auto border-azul rounded mb-1">
            <legend
              className="float-none m-0 w-auto fw-bold"
              style={{ fontSize: "0.8rem" }}
            >
              AGRUPAR POR:
            </legend>
            <div className="col-12 row mb-2 m-0 d-flex justify-content-between align-items-center">
              <div className="form-check col-auto">
                <input
                  className="form-check-input"
                  type="radio"
                  name="radio"
                  id="inlineRadiot1"
                  value="1"
                  ref={txtpedido}
                  defaultChecked
                />
                <label
                  className="form-check-label text-uppercase"
                  htmlFor="inlineRadiot1"
                  style={{ fontSize: "0.8rem" }}
                >
                  Por Pedidos
                </label>
              </div>

              <div className="form-check col-auto">
                <input
                  className="form-check-input"
                  type="radio"
                  name="radio"
                  id="inlineRadiot2"
                  value="2"
                  ref={txtproducto}
                />
                <label
                  className="form-check-label text-uppercase"
                  htmlFor="inlineRadiot2"
                  style={{ fontSize: "0.8rem" }}
                >
                  Por Producto
                </label>
              </div>
            </div>
          </fieldset>
          <fieldset className="row col-sm-12 mx-auto border-azul rounded mb-1">
            <legend
              className="float-none m-0 w-auto fw-bold"
              style={{ fontSize: "0.8rem" }}
            >
              VENDEDOR
            </legend>
            <div className="col-2 mx-auto">
              <div className="form-check">
                <input
                  className="form-check-input"
                  name="vendedor"
                  type="radio"
                  onChange={() => {
                    setActCliente(true);
                    setIdVendedor("");
                    txtNombreVendedor.current.value = "";
                    txtRifVendedor.current.value = "";
                  }}
                  defaultChecked
                />
                <label className="form-check-label" for="exampleRa1">
                  Todos
                </label>
              </div>
            </div>
            <div className="col-2 mx-auto">
              <div className="form-check">
                <input
                  className="form-check-input"
                  name="vendedor"
                  type="radio"
                  onChange={() => {
                    setActCliente(false);
                  }}
                />
                <label className="form-check-label" for="exampleRa2">
                  Por Vendedor
                </label>
              </div>
            </div>
            <div className="col-7 mr-auto px-0">
              <div className="input-group input-group-sm col-7 px-1 ml-auto">
                <label className="input-group-text" id="inputGroup-sizing-sm">
                  RIF:
                </label>
                <input
                  type="text"
                  disabled={true}
                  ref={txtRifVendedor}
                  className="form-control text-uppercase"
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-sm"
                />
                <button
                  type="button"
                  className="btn btn-success"
                  disabled={actCliente}
                  onClick={() => {
                    setMostrarCliente(true);
                  }}
                >
                  <i className="fas fa-search"></i>
                </button>
              </div>
            </div>
            <div className="col-12 row m-0 py-3">
              <div className="col-12">
                <div className="input-group input-group-sm">
                  <label className="input-group-text" id="inputGroup-sizing-sm">
                    NOMBRE DEL VENDEDOR:
                  </label>
                  <input
                    type="text"
                    disabled={true}
                    ref={txtNombreVendedor}
                    className="form-control"
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-sm"
                  />
                </div>
              </div>
            </div>
          </fieldset>
          <fieldset className="row col-sm-12 mx-auto border-azul rounded mb-1">
            <legend
              className="float-none m-0 w-auto fw-bold"
              style={{ fontSize: "0.8rem" }}
            >
              ALMACEN
            </legend>
            <div className="col-2 mx-auto">
              <div className="form-check">
                <input
                  className="form-check-input"
                  name="alamcen"
                  type="radio"
                  onChange={() => {
                    setActAlmacen(true);
                    setIdAlmacen("");
                    txtNombreAlmacen.current.value = "";
                    txtCodigoAlmacen.current.value = "";
                  }}
                  defaultChecked
                />
                <label className="form-check-label" for="exampleRa1">
                  Todos
                </label>
              </div>
            </div>
            <div className="col-2 mx-auto">
              <div className="form-check">
                <input
                  className="form-check-input"
                  name="alamcen"
                  type="radio"
                  onChange={() => {
                    setActAlmacen(false);
                  }}
                />
                <label className="form-check-label" for="exampleRa2">
                  Por Almacen
                </label>
              </div>
            </div>
            <div className="col-7 mr-auto px-0">
              <div className="input-group input-group-sm col-7 px-1 ml-auto">
                <label className="input-group-text" id="inputGroup-sizing-sm">
                  CODIGO ALMACEN:
                </label>
                <input
                  type="text"
                  disabled={true}
                  ref={txtCodigoAlmacen}
                  className="form-control text-uppercase"
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-sm"
                />
                <button
                  type="button"
                  className="btn btn-success"
                  disabled={actAlmacen}
                  onClick={() => {
                    setMostrarAlmacen(true);
                  }}
                >
                  <i className="fas fa-search"></i>
                </button>
              </div>
            </div>

            <div className="col-12 row m-0 py-3">
              <div className="col-12">
                <div className="input-group input-group-sm">
                  <label className="input-group-text" id="inputGroup-sizing-sm">
                    NOMBRE DEL ALMACEN:
                  </label>
                  <input
                    type="text"
                    disabled={true}
                    ref={txtNombreAlmacen}
                    className="form-control"
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-sm"
                  />
                </div>
              </div>
            </div>
          </fieldset>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div className="row m-0 col-md-12 mx-auto">
          <div className="col-md-11 ml-auto px-0 m-0 d-flex justify-content-end">
            <button
              onClick={onChangeValidar}
              className="btn btn-sm rounded-pill btn-primary mx-1"
            >
              <i className="fas fa-print"> Imprimir</i>
            </button>
            <button
              onClick={cancelar}
              className="btn btn-danger btn-sm rounded-pill mx-1"
            >
              <i className="fas fa-window-close"> Cancelar</i>
            </button>
          </div>
        </div>
      </Modal.Footer>
      <CatalogoAlmacen
        show={mostrarAlmacen}
        onHideCancelar={() => setMostrarAlmacen(false)}
        onHideAceptaCatalogo={handleAceptaAlmacen}
      />
      <CatalogoCliente
        show={mostrarCliente}
        nomid={"vendedor"}
        onHideCancelar={() => setMostrarCliente(false)}
        onHideAceptaCatalogo={handleAceptaVendedor}
      />
    </Modal>
  );
};



// WEBPACK FOOTER //
// ./src/components/ventas/ImprimirPedidosPendientes.js